import React from "react";
import Aside3 from "../../reduxworkbook/Aside3";
import FilterItem from "../../reduxworkbook/dashboard/FilterItem";
import {
  TbLayoutSidebarLeftCollapseFilled,
  TbLayoutSidebarRightCollapseFilled,
} from "react-icons/tb";
import { useSelector } from "react-redux";
import {
  getL1SheetProperty,
  getL2SheetProperty,
} from "../../reduxworkbook/WorkbookSlice";
import CordinateMap from "../../../components/VizComponents/MapWithCordinate/CordinateMap";

export default function ViewWBCharts({
  droppableAreaRef,
  gridSize,
  currentSheet,
  itemRef,
  snapToGrid,
  buttonRef,
  setFilterSideBar,
  filterSideBar,
  sheetId,
}) {
  console.log(currentSheet);

  const headerVisiblityArray =
    useSelector((state) =>
      getL1SheetProperty(state, sheetId, "headerVisibility")
    ) || [];
  console.log(headerVisiblityArray);
  function isHeadingVisible(headerVisiblityArray, sheetId) {
    let isHeadingVisible;
    const isPresent = headerVisiblityArray.find(
      (SheetId) => SheetId === sheetId
    );
    if (isPresent) {
      isHeadingVisible = true;
    } else {
      isHeadingVisible = false;
    }
    return isHeadingVisible;
  }

  return (
    <main className="w-full items-center justify-center flex gap-0 h-[91%]">
      <main
        ref={droppableAreaRef}
        className={`relative flex flex-wrap items-start justify-start border w-full h-full p-2 overflow-hidden ${
          currentSheet.SheetType === "chart" ? "" : "overflow-y-auto"
        } `}
      >
        {gridSize > 0 &&
        currentSheet.SheetType === "dashboard" &&
        currentSheet.SheetsArray.length > 0 ? (
          currentSheet.SheetsArray.map((item) => {
            console.log(item);
            return (
              <main
                key={item.Sheetid}
                ref={itemRef}
                style={{
                  left: snapToGrid(item.x, gridSize),
                  top: snapToGrid(item.y, gridSize),
                  width: snapToGrid(item.width, gridSize),
                  height: snapToGrid(item.height, gridSize),
                }}
                className="absolute flex flex-col items-center justify-center border overflow-hidden"
              >
                {isHeadingVisible(headerVisiblityArray, item.Sheetid) ? (
                  <header
                    className="w-full flex items-start justify-start px-1 font-[500] text-base h-auto"
                    ref={buttonRef}
                  >
                    {item.SheetName}
                  </header>
                ) : null}
                <main
                  className={`flex w-full ${
                    isHeadingVisible(headerVisiblityArray, item.Sheetid)
                      ? "h-[91%]"
                      : "h-full"
                  } items-center justify-center`}
                >
                  {!["cordinatemap"].includes(item.SheetVizType) ? (
                    <Aside3
                      currentSheet={{
                        Sheetid: item.Sheetid,
                        SheetName: item.SheetName,
                      }}
                      isSheetInDashboard={true}
                      workbookType={"published"}
                      widthHeightObject={{
                        width: snapToGrid(item.width, gridSize),
                        height: snapToGrid(item.height, gridSize),
                      }}
                    />
                  ) : null}
                  {item.SheetVizType === "cordinatemap" ? (
                    <CordinateMap
                      Sheetid={item.Sheetid}
                      vizType={item.SheetVizType}
                      dataSourceID={item.dataSourceID}
                      workbookType={"published"}
                      isSheetInDashboard={true}
                      widthHeightObject={{
                        width: snapToGrid(item.width, gridSize),
                        height: snapToGrid(item.height, gridSize),
                      }}
                    />
                  ) : null}
                </main>
              </main>
            );
          })
        ) : currentSheet.SheetVizType === "cordinatemap" ? (
          <CordinateMap
            Sheetid={currentSheet.Sheetid}
            vizType={currentSheet.SheetVizType}
            dataSourceID={currentSheet.SheetDataSourceID}
            workbookType={"published"}
            isSheetInDashboard={true}
            widthHeightObject={{
              width: "100%",
              height: "100%",
            }}
          />
        ) : (
          <Aside3 currentSheet={currentSheet} isSheetInDashboard={true} />
        )}
      </main>

      {/* Render the aside conditionally only if currentSheet.sheetType is "dashboard" */}
      {filterSideBar ? (
        <aside className="sm:w-[35%] md:w-[12%] border-l-1 border-blue-950 h-full flex flex-col items-center justify-start py-2">
          <button className="w-full flex items-center justify-end">
            <TbLayoutSidebarRightCollapseFilled
              onClick={() => setFilterSideBar(!filterSideBar)}
            />
          </button>
          <FilterItem
            dashboardSheetID={currentSheet.Sheetid}
            droppedSheetsArray={currentSheet.SheetsArray}
            currentSheetID={sheetId}
            currentSheetType={currentSheet.SheetType}
            isFilterVisibleInDashboard={true}
            dashboardType={"viewDashboard"}
          />
        </aside>
      ) : (
        <aside className="sm:w-[3%] md:w-[1%] border-l-1 border-blue-950 h-full flex flex-col items-center justify-start py-2">
          <button className="w-full flex items-center justify-end">
            <TbLayoutSidebarLeftCollapseFilled
              onClick={() => setFilterSideBar(!filterSideBar)}
            />
          </button>
        </aside>
      )}
    </main>
  );
}
